/**
 * Pill-shaped tab control (in-page navigation)
 */

export interface PillTabOption<T extends string = string> {
  value: T
  label: string
}

interface PillTabsProps<T extends string> {
  value: T
  onChange: (value: T) => void
  options: PillTabOption<T>[]
  className?: string
}

export function PillTabs<T extends string>({
  value,
  onChange,
  options,
  className = '',
}: PillTabsProps<T>) {
  return (
    <div
      className={`inline-flex flex-wrap items-center gap-1 rounded-pill border border-gray-200/80 bg-gray-100/90 p-1 shadow-inset ${className}`}
      role="tablist"
    >
      {options.map(opt => {
        const selected = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(opt.value)}
            className={`rounded-pill px-4 py-2 text-sm font-medium transition-colors ${
              selected
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
